module.exports = __webpack_public_path__ + "files/c37b956bfc3cd998d4a1efc6e132614a.png";